import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import MuiSelect from '@material-ui/core/Select';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Tooltip from '@material-ui/core/Tooltip';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Numeral from 'numeral';
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}));

const Select = withStyles((theme) => ({
  root: {
    padding: '12px 14px',
  },
}))(MuiSelect);

const DialogInformasiDetails = (props) => {
  const classes = useStyles();
  const {detailNop, detailSppt, tahunSPPT, handleTahunSPPT, itemTahunSPPT} = props;

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4} lg={4}>
          <Grid container spacing={1}>
            <Grid item xs={12} style={{backgroundColor: '#ECF0F1'}}>
              Objek Pajak
            </Grid>
            {/*  NOP  */}
            <Grid item xs={12} md={12} lg={12} style={{fontWeight: 'bold'}}>
              {detailNop.nop}
            </Grid>

            {/*  Alamat Objek Pajak  */}
            <Grid item xs={5} md={5} lg={5}>
              Alamat
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.jalan_op}
            </Grid>

            {/*  Blok/Kav/No. Objek Pajak */}
            <Grid item xs={5} md={5} lg={5}>
              Blok / Kav / No.
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.blok_kav_no_op}
            </Grid>

            {/*  RT/RW Objek Pajak  */}
            <Grid item xs={5} md={5} lg={5}>
              RT / RW
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.rt_op} / {detailNop.rw_op}
            </Grid>

            {/*  Kode ZNT  */}
            <Grid item xs={5} md={5} lg={5}>
              Kode ZNT
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.kd_znt} / {detailNop.nir}
            </Grid>

            {/*  Jenis Bumi  */}
            <Grid item xs={5} md={5} lg={5}>
              Jenis Bumi
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.jenis_bumi}
            </Grid>

            {/*  Jumlah Bangunan  */}
            <Grid item xs={5} md={5} lg={5}>
              Jumlah Bangunan
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.no_bng}
            </Grid>

            <Grid item xs={12} />
            <Grid item xs={12} />
            <Grid item xs={12} />

            <Grid item xs={12} style={{backgroundColor: '#ECF0F1'}}>
              Subjek Pajak
            </Grid>

            {/*  Wajib Pajak  */}
            <Grid item xs={5} md={5} lg={5}>
              Wajib Pajak
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.nm_wp}
            </Grid>

            {/*  Alamat Wajib Pajak */}
            <Grid item xs={5} md={5} lg={5}>
              Alamat
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.alamat_wp}
            </Grid>

            {/*  Blok/Kav/No. Wajib Pajak */}
            <Grid item xs={5} md={5} lg={5}>
              Blok / Kav / No.
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.blok_wp}
            </Grid>

            {/*  RT/RW Wajib Pajak */}
            <Grid item xs={5} md={5} lg={5}>
              RT / RW
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.rt_wp} / {detailNop.rw_wp}
            </Grid>

            {/*  Kelurahan Wajib Pajak */}
            <Grid item xs={5} md={5} lg={5}>
              Kelurahan
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.nm_kelurahan}
            </Grid>

            {/*  Kabupaten Wajib Pajak */}
            <Grid item xs={5} md={5} lg={5}>
              Kecamatan
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.nm_kecamatan}
            </Grid>

            {/*  Status Pekerjaan  */}
            <Grid item xs={5} md={5} lg={5}>
              Status Pekerjaan
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.pekerjaan}
            </Grid>

            {/*  Status Wajib Pajak  */}
            <Grid item xs={5} md={5} lg={5}>
              Status WP
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.status_subjek}
            </Grid>

            {/*  Kode Pos  */}
            <Grid item xs={5} md={5} lg={5}>
              Kode Pos
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.kodepos_wp}
            </Grid>

            {/*  No.Telepon  */}
            <Grid item xs={5} md={5} lg={5}>
              No.Telepon
            </Grid>
            <Grid item xs={7} md={7} lg={7}>
              : {detailNop.telp_wp}
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={8} lg={8}>
          <Grid container spacing={1}>
            <Grid item xs={12} style={{backgroundColor: '#ECF0F1'}}>
              SPPT
            </Grid>
            {/*  Tahun SPPT  */}
            <Grid item xs={12} style={{marginTop: 15, marginBottom: 5}}>
              <FormControl variant="outlined" style={{minWidth: 160}}>
                <InputLabel>Tahun SPPT</InputLabel>
                <Select value={tahunSPPT} onChange={handleTahunSPPT} label="Tahun SPPT">
                  {itemTahunSPPT.map((value, key) => {
                    return (
                      <MenuItem key={key} value={value.thn_pajak_sppt}>
                        {value.thn_pajak_sppt}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            {/*  Wajib Pajak  */}
            <Grid item xs={5} md={3}>
              Wajib Pajak
            </Grid>
            <Grid item xs={7} md={3}>
              : {detailSppt.nm_wp}
            </Grid>

            {/*  Alamat Wajib Pajak  */}
            <Grid item xs={5} md={3}>
              Alamat
            </Grid>
            <Grid item xs={7} md={3}>
              : {detailSppt.jln_wp}
            </Grid>

            {/*  Blok/Kav/No. Wajib Pajak  */}
            <Grid item xs={5} md={3}>
              Blok/Kav/No.
            </Grid>
            <Grid item xs={7} md={3}>
              : {detailSppt.blok_kav_no_wp}
            </Grid>

            {/*  RT/RW  */}
            <Grid item xs={5} md={3}>
              RT / RW
            </Grid>
            <Grid item xs={7} md={3}>
              : {detailSppt.rt_wp} / {detailSppt.rw_wp}
            </Grid>

            {/*  Kelurahan  */}
            <Grid item xs={5} md={3}>
              Kelurahan
            </Grid>
            <Grid item xs={7} md={3}>
              : {detailSppt.nm_kelurahan}
            </Grid>

            {/*  Kabupaten  */}
            <Grid item xs={5} md={3}>
              Kecamatan
            </Grid>
            <Grid item xs={7} md={3}>
              : {detailSppt.nm_kecamatan}
            </Grid>

            {/*  Tanggal Jatuh Tempo SPPT  */}
            <Grid item xs={5} md={3}>
              Tanggal Jatuh Tempo
            </Grid>
            <Grid item xs={7} md={3}>
              : {detailSppt.tgl_jatuh_tempo}
            </Grid>

            {/*  Status Pembayaran SPPT  */}
            <Grid item xs={5} md={3}>
              Status Pembayaran
            </Grid>
            <Grid item xs={7} md={3}>
              : {detailSppt.status_pembayaran}
            </Grid>

            {/*  Tanggal Pembayaran SPPT  */}
            <Grid item xs={5} md={3}>
              Tanggal Pembayaran
            </Grid>
            <Grid item xs={7} md={3}>
              : {detailSppt.tgl_pembayaran}
            </Grid>

            {/*  Tempat Pembayaran SPPT  */}
            <Grid item xs={5} md={3}>
              Tempat Pembayaran
            </Grid>
            <Grid item xs={7} md={3}>
              : {detailSppt.nm_tp}
            </Grid>

            <Grid item xs={12}>
              <Divider style={{marginTop: 10, marginBottom: 10}} />
            </Grid>

            {/*  Header SPPT  */}
            <Grid item xs={3} sm={2} />
            <Hidden xsDown>
              <Grid item sm={2} style={{textAlign: 'center'}}>
                Kelas
              </Grid>
            </Hidden>
            <Grid item xs={4} sm={2} style={{textAlign: 'center'}}>
              Luas
            </Grid>
            <Hidden xsDown>
              <Grid item sm={2}>
                NJOP M<sup>2</sup>
              </Grid>
            </Hidden>
            <Grid item xs={5} sm={4}>
              Jumlah NJOP
            </Grid>

            {/*  Details Bumi SPPT  */}
            <Grid item xs={3} sm={2}>
              Bumi
            </Grid>
            <Hidden xsDown>
              <Grid item sm={2} style={{textAlign: 'center'}}>
                {detailSppt.kd_kls_tanah} / {detailSppt.thn_awal_kls_tanah}
              </Grid>
            </Hidden>
            <Grid item xs={4} sm={2} style={{textAlign: 'center'}}>
              {Numeral(detailSppt.luas_bumi).format('0,0')}
            </Grid>
            <Hidden xsDown>
              <Grid item sm={2}>
                Rp.{Numeral(detailSppt.njop_bumi_m2_sppt).format('0,0')}
              </Grid>
            </Hidden>
            <Grid item xs={5} sm={4}>
              Rp.{Numeral(detailSppt.njop_bumi).format('0,0')}
            </Grid>

            {/*  Details Bangunan SPPT  */}
            <Grid item xs={3} sm={2}>
              Bangunan
            </Grid>
            <Hidden xsDown>
              <Grid item sm={2} style={{textAlign: 'center'}}>
                {detailSppt.kd_kls_bng} / {detailSppt.thn_awal_kls_bng}
              </Grid>
            </Hidden>
            <Grid item xs={4} sm={2} style={{textAlign: 'center'}}>
              {Numeral(detailSppt.luas_bng).format('0,0')}
            </Grid>
            <Hidden xsDown>
              <Grid item sm={2}>
                Rp.{Numeral(detailSppt.njop_bng_m2_sppt).format('0,0')}
              </Grid>
            </Hidden>
            <Grid item xs={5} sm={4}>
              Rp.{Numeral(detailSppt.njop_bng).format('0,0')}
            </Grid>

            <Grid item xs={5} sm={8} />
            <Grid item xs={7} sm={4}>
              <Divider style={{marginTop: 10, marginBottom: 10}} />
            </Grid>

            {/*  NJOP SPPT  */}
            <Grid item xs={5} sm={8}>
              Total NJOP
            </Grid>
            <Grid item xs={7} sm={4}>
              Rp.{Numeral(detailSppt.njop).format('0,0')}
            </Grid>

            {/*  NJOPTKP SPPT  */}
            <Grid item xs={5} sm={8}>
              NJOPTKP
            </Grid>
            <Grid item xs={7} sm={4}>
              Rp.{Numeral(detailSppt.njoptkp).format('0,0')}
            </Grid>

            {/*  PBB TERUTANG SPPT  */}
            <Grid item xs={5} sm={8}>
              PBB Terhutang
            </Grid>
            <Grid item xs={7} sm={4}>
              Rp.{Numeral(detailSppt.jml_terhutang).format('0,0')}
            </Grid>

            {/*  FAKTOR PENGURANG SPPT  */}
            <Grid item xs={5} sm={8}>
              Faktor Pengurang
            </Grid>
            <Grid item xs={7} sm={4}>
              Rp.{Numeral(detailSppt.faktor_pengurang).format('0,0')}
            </Grid>

            {/*  PBB YANG HARUS DIBAYAR SPPT  */}
            <Grid item xs={5} sm={8}>
              PBB Yang Harus Dibayar
            </Grid>
            <Grid item xs={7} sm={4}>
              Rp.{Numeral(detailSppt.jml_yg_harus_dibayar).format('0,0')}
            </Grid>

            {/*  Denda SPPT  */}
            <Grid item xs={5} sm={8}>
              Denda
            </Grid>
            <Grid item xs={7} sm={4}>
              Rp.{Numeral(detailSppt.denda).format('0,0')}
            </Grid>

            {/*  PBB Yang Telah Dibayar SPPT  */}
            <Grid item xs={5} sm={8}>
              PBB Yang Telah Dibayar
            </Grid>
            <Grid item xs={7} sm={4}>
              Rp.{Numeral(detailSppt.jml_yg_dibayar).format('0,0')}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default DialogInformasiDetails;
